import React from 'react'
import styled from "styled-components"
import { colors, mediaQueries } from '../shared/config'
import ImageWithPullquote from './ImageWithPullquote';
// import { fonts, mediaQueries } from "../shared/config";
const { mobile, tablet } = mediaQueries;

const navLinks = [
    {
        name: "instagram",
        link : "https://www.instagram.com/dailybruin/",
        icon : ""
    },
    {
        name: "facebook",
        link : "https://www.facebook.com/dailybruin/",
        icon : "fab fa-facebook",
    },
    {
        name: "twitter",
        link: "https://twitter.com/dailybruin",
        icon : "fab fa-twitter"
    },
    {
        name: "tiktok",
        link : "https://www.instagram.com/dailybruin/",
        icon: "fab fa-tiktok",
    },
    {
        name: "email",
        link : "https://www.instagram.com/dailybruin/",
    }
]

const Gallery = styled("div")`
display: flex;
flex-direction: row;
margin-top: 40px;

${tablet} {
   flex-direction: column !important;
   justify-content: center !important;
    align-items: center !important;
 }
${mobile} {
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
  }
 
`;

const ImageContainer = styled("div")`
display: flex;
flex-direction: column;
font-size: 12px;
text-align: center;
color: white;
width: 100%;
${tablet} {
    /* width: 60%; */
   flex-direction: column;
   justify-content: center !important;
   align-items: center !important;
 }
${mobile} {
    /* width: 60%; */
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;
    font-size: 8px;
  }
`;

const Image = styled("img")`
/* width: 200px; */
height: 100%;
width: 300px;
object-fit: cover;
${tablet} {
  height: auto;
  width: 80%;
 }
${mobile} {
    height: auto;
    width: 80%;
  }

`;


function Footer(props) {
    let content = "";
    let link = "";
    let credits="";
    let quote="";
    let images=[]
    for (var i = 0; i < props.data.length; i++) {
        if (props.data[i].type == "paragraph") {
            content+=props.data[i].content+"<br><br>";
        }
        if (props.data[i].type == "image_next_to_pullquote") {
            link = props.data[i].image_link;
            credits = props.data[i].image_credits;
        }
        if (props.data[i].type == "pullquote") {
            quote = props.data[i].content;
        }
        if (props.data[i].type == "image") {
            images.push(props.data[i]);
        }
    }
    
    return (
        <Background>
            <DescriptionContainer>
                <Heading> A Silver Lining </Heading>
                <SubHeading> sneakers in the 21st century and beyond</SubHeading>
                <Text dangerouslySetInnerHTML={{__html: content}}>
                </Text>
                <ImageWithPullquote image={link} quote={quote} credits={credits}></ImageWithPullquote>
            
            
            <Gallery>
            {images.map(block=>{
                    return (
                        <ImageContainer>
                            <Image src={block.image_link} alt=""></Image>
                            {block.image_credits}
                        </ImageContainer>
                    );
                })}
            </Gallery>
            </DescriptionContainer>
            {/* <FooterContainer>
                <FooterHeader>
                    DAILY BRUIN
                </FooterHeader>
                <nav>
                    <IconContainer>
                        {navLinks.map((navLink, index) => 
                            <Icon key={index} className="fab fa-facebook" style={{color:"white", size: "9px"}}>
                                <a href={navLink.link}></a>
                            </Icon>
                        )}
                    </IconContainer>
                </nav>
            </FooterContainer>
            <ClosingCredits>
                Labore ut nulla deserunt sit est consectetur non.
            </ClosingCredits> */}
        </Background>
    )
}

const Background = styled.div`
    background-color : ${colors.black};
    height: 100%;
`

const Container = styled.div`
    width: 80%;
    
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    ${mediaQueries.mobile}{
        width: 90%;

    }
`

const DescriptionContainer = styled(Container)`
    height: auto;
    text-align: left;
    ${mediaQueries.mobile} {
        margin: 0 30px;
        text-align: center;
        align-items: center;
    }
`
const FooterContainer = styled(Container)`
    padding-bottom: 3em;
`

const Heading = styled.p`
    padding-top: 80px;
    font-size: 72px;
    font-family: Staatliches;
    font-style: normal;
    font-weight: normal;
    text-transform: uppercase;
    font-size: 72px;
    line-height: 75%;
    color: ${colors.red};
    margin: 0 0 0.1em 0;
    ${mediaQueries.mobile} {
        font-size: 36px;
    }
`

const SubHeading = styled.p`
    padding-top: 10px;
    padding-bottom: 70px;
    font-family: Staatliches;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 75%;
    text-transform: uppercase;
    color: white;
    margin: 0 0 0.5em;
    ${mediaQueries.mobile} {
        font-size: 24px;
        width: 60%;
    }
`

const Text = styled.p`
    color: white;
    text-align: left;
    font-family: Cardo;
    font-style: normal;
    font-weight: normal;
`

const FooterHeader = styled.h1`
    color: white;
    font-family: ITC Century;
    font-style: normal;
    font-weight: normal;
    line-height: 35px;
    font-size: 18px;
`

const IconContainer = styled.ul`
    margin: 0;
    padding: 0;
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${mediaQueries.mobile} {
        width: 200px;
    }
`

const Icon = styled.li`
    font-size: 3em;
    ${mediaQueries.mobile}{
        font-size: 2em;
    }
`

const ClosingCredits = styled.p`
    color: white;
    font-family: Avenir;
    font-style: normal;
    font-weight: 500;
    margin-bottom : 0px;
    padding-bottom: 1.5em;
    ${mediaQueries.mobile} {
        font-size: 10px;
    }
`
export default Footer
